import { MainLayout } from "@/components/layout/MainLayout";
import { PatientRegistrationForm } from "@/components/patients/PatientRegistrationForm";

const Registration = () => {
  return (
    <MainLayout>
      <PatientRegistrationForm />
    </MainLayout>
  );
};

export default Registration;
